<template>
  <div class="filter-message-container">
    <div v-if="isMobile && profileStatus === 'agent'" class="client-name">
      <span>Client: {{ clientName }}</span>
    </div>
    <dialog-search
      :date-sort="dateSort"
      :active-sort-list="sortTypes"
      @sort-by-date="sortByDate($event)"
      @sort-by-types="sortByTypes($event)"
    />
    <v-btn
      color="#232C43"
      class="message-btn"
      @click="$emit('on-new-thread')"
    >
      New Message
    </v-btn>
    <threads-list
      :list="threads"
      :sort-types="sortTypes"
      :sort-date="dateSort"
      :sender="sender"
      class="filtered-message-list"
      @select-thread="$emit('select-thread', $event)"
    />
  </div>
</template>

<script>
import DialogSearch from '../../components/communication/DialogSearch'
import ThreadsList from '../../components/communication/ThreadsList'
import { mapState } from 'vuex'
export default {
  components: {
    DialogSearch,
    ThreadsList
  },
  props: {
    threads: {
      type: Array,
      default: () => ([])
    },
    sender: {
      type: Object,
      default: () => ({})
    },
    savedSort: {
      type: Object,
      default: null
    },
    clientName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      sortTypes: [
        'offer_message',
        'provide_feedback_message',
        'home_message',
        'common_message',
        'route_schedule_message'
      ],
      dateSort: false
    }
  },
  computed: {
    ...mapState('common', ['isMobile', 'profileStatus'])
  },
  mounted() {
    if (this.savedSort) {
      this.sortTypes = this.savedSort.types
      this.dateSort = this.savedSort.date
    }
  },
  methods: {
    sortByTypes(types) {
      this.sortTypes = types
      this.$emit('update-saved-sort', {
        types: this.sortTypes,
        date: this.dateSort
      })
    },
    sortByDate() {
      this.dateSort = !this.dateSort
      this.$emit('update-saved-sort', {
        types: this.sortTypes,
        date: this.dateSort
      })
    }
  }
}
</script>

<style lang="sass" scoped>
#containerClientCommunication
  .filtered-message-list
    height: calc(100% - 148px)

.filter-message-container
  overflow: hidden
  height: 100%
  width: 100%
  display: block
  background-color: #fff
  border-left: 1px solid #ececec
  border-right: 1px solid #ececec
.filter-message-container .client-name
  margin: 5px 0
  text-transform: capitalize
.filtered-message-list
  width: 100%
  height: calc(100% - 220px)
  overflow: scroll
  @media only screen and (max-width: 600px)
    height: calc(100% - 175px)
.message-btn
  font-weight: bold
  color: $hwayzWhite !important
  width: 80%
  height: 40px
  margin: 20px auto
  font-weight: 500
  border-radius: 5px
.v-btn__content
  height: 3rem
</style>

<style lang="sass">
.filtered-message-list
  .v-divider
    margin: 0
</style>
